import { render, staticRenderFns } from "./ThumbnailGroup.vue?vue&type=template&id=d63e032a&scoped=true&"
import script from "./ThumbnailGroup.vue?vue&type=script&lang=js&"
export * from "./ThumbnailGroup.vue?vue&type=script&lang=js&"
import style0 from "./ThumbnailGroup.vue?vue&type=style&index=0&id=d63e032a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63e032a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d63e032a')) {
      api.createRecord('d63e032a', component.options)
    } else {
      api.reload('d63e032a', component.options)
    }
    module.hot.accept("./ThumbnailGroup.vue?vue&type=template&id=d63e032a&scoped=true&", function () {
      api.rerender('d63e032a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/ThumbnailGroup.vue"
export default component.exports